import { Box } from "@mui/material";
import { styled } from "@mui/styles";

export const ModalButtonContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
    "& .MuiTypography-root": {
        fontFamily: "'YekanBold !important'",
        fontSize: ".9rem"
    },
    width: "70%",
    justifyContent: "center",
    gap: "1rem",
    alignItems: "center",
    marginTop: "1.5rem !important",
});

export const PositiveModalButton = {
    fontFamily: "'YekanBold !important'",
    fontSize: "1rem",
    width: "100%",
    backgroundColor: "rgb(201, 126, 245)",
    borderRadius: "15px",
    padding: ".7rem 0",
};
export const NegativeModalButton = {
    fontFamily: "'YekanBold !important'",
    fontSize: "1rem",
    width: "100%",
    borderRadius: "15px",
    padding: ".7rem 0",
};
export const smallButton = {
    fontFamily: "'YekanBold !important'",
    fontSize: ".9rem",
    width: "fit-content",
    minWidth: "8rem",
    gap: ".2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "15px",
    padding: ".5rem",
}
export const HalfWidthButton = {
    fontFamily: "'YekanBold !important'",
    maxWidth: "50%",
    fontSize: "1rem",
    width: "100%",
    borderRadius: ".6rem",
    padding: ".5rem 0",
    backgroundColor: "customColors.purple",
    ":hover": {
        backgroundColor: "divider"
    }
}  